<template>
  <div>
    <cs-dialog v-model="isShownDialog">
      <dialog-list-layout>
        <div :class="$style.container">
          <div :class="$style.title">
            <span>{{ $t('transactions.status') }}</span>
          </div>
          <div :class="$style.content">
            <div
              v-for="(status, idx) in statusesList"
              :key="idx"
              :class="$style.panel"
            >
              <toggle-panel
                v-model="status.value"
                :title="status.description"
                @click="handleChangeByIdx(idx)"
              >
                <component
                  :is="status.icon.component"
                  slot="icon"
                  :fill="status.icon.fill"
                />
              </toggle-panel>
            </div>
          </div>
          <div :class="$style.footer">
            <div :class="$style.submit">
              <cs-button width="100%" @click="handleSubmit">
                {{ $t('common.save') }}
              </cs-button>
            </div>
            <cs-button type="transparent" @click="isShownDialog = false">
              {{ $t('common.cancel') }}
            </cs-button>
          </div>
        </div>
      </dialog-list-layout>
    </cs-dialog>
  </div>
</template>

<script>
import { EVENT_BUS } from '@/eventBus';

import TogglePanel from 'molecules/panels/TogglePanel';
import DialogListLayout from 'modules/Dialogs/ListLayout';

import CheckMarkIcon from 'atoms/icons/basic/CheckMark';
import CircleMinusIcon from 'atoms/icons/basic/CircleMinus';

import { SUCCESS, DECLINE } from './const';

export default {
  name: 'SelectingTransactionStatuses',
  components: {
    TogglePanel,
    DialogListLayout,
    CheckMarkIcon,
    CircleMinusIcon,
  },
  created() {
    EVENT_BUS.$on('SELECTING_TRANSACTION_STATUSES', statuses => {
      this.prepareStatuses(statuses);
      this.isShownDialog = true;
    });
  },
  data() {
    return {
      statusesList: [
        {
          keys: [SUCCESS],
          description: this.$t('common.successfuls'),
          value: true,
          icon: {
            component: 'CheckMarkIcon',
            fill: '#7CB342',
          },
        },
        {
          keys: [DECLINE],
          description: this.$t('common.canceled'),
          value: true,
          icon: {
            component: 'CircleMinusIcon',
            fill: '#DADADA',
          },
        },
      ],
      currentStatuses: [],
      isShownDialog: false,
    };
  },
  computed: {
    isLockedToChange() {
      return this.statusesList.filter(type => type.value).length === 1;
    },
    activatedStatuses() {
      return this.statusesList
        .filter(status => status.value)
        .map(status => status.keys)
        .join(',');
    },
  },
  methods: {
    prepareStatuses(rowValues) {
      if (this.$validate.isEmptyString(rowValues)) {
        return;
      }

      const splitedValues = rowValues.split(',');
      const preparedStatuses = this.statusesList.map(status => {
        const isIncluded = splitedValues
          .some(currentStatus => status.keys.includes(currentStatus));

        return {
          ...status,
          value: isIncluded,
        };
      });

      this.statusesList = preparedStatuses;
    },
    handleChangeByIdx(idx) {
      const changedItem = this.statusesList[idx];

      if (changedItem.value && this.isLockedToChange) {
        this.$alert({
          type: 'warning',
          text: this.$t('must.choosed.one.value'),
        });
        return;
      }

      changedItem.value = !changedItem.value;
    },
    handleSubmit() {
      EVENT_BUS.$emit('SELECTED_TRANSACTION_STATUSES', this.activatedStatuses);
      this.isShownDialog = false;
    },
  },
};
</script>

<style lang="sass" module>
  .container

  .title
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 20px
    font-weight: 600
    font-size: 20px
    line-height: 30px
    color: #fff

  .content
    margin-bottom: 20px

  .panel
    &:not(:last-child)
      margin-bottom: 10px

  .footer
    text-align: center

    +respond-to('small')
      display: flex
      justify-content: space-between

  .submit
    width: 100%
    margin-bottom: 10px

    +respond-to('small')
      width: 230px
      margin-bottom: 0
</style>
